import React from 'react';
import { Address, AddressType } from '../types/Address';
import { useTranslations } from '../../localization/useTranslations';
import { useAddresses } from '../hooks/useAddresses';

interface AddressCardProps {
  address: Address;
}

const AddressCard: React.FC<AddressCardProps> = ({ address }) => {
  const translations = useTranslations();
  const { renderAddressLabelByType } = useAddresses();

  const renderCountryFieldByIso = (iso: string) => {
    if (!iso) return '';

    switch (iso.toLowerCase()) {
      case 'cz':
        return translations.general.czechRepublic || 'Czech Republic';
      case 'sk':
        return translations.general.slovakia || 'Slovakia';
      default:
        return iso;
    }
  };

  // Helper function to check if a field is valid (not null, undefined, or string "null")
  const isValidField = (field: string | null | undefined) => field && field.toLowerCase() !== 'null';

  return (
    <div className="my-settings__column my-settings__column--address">
      <span className="my-settings__label basic basic-16">
        {`${renderAddressLabelByType(address.type as AddressType)} ${
          translations.myAccountSettings.address || 'Address'
        }`}
      </span>
      {isValidField(address.firstName) && isValidField(address.lastName) && (
        <span className="my-settings__text basic basic-16 name">{`${address.firstName} ${address.lastName}`}</span>
      )}
      {isValidField(address.address) && (
        <span className="my-settings__text basic basic-16 address">
          {`${address.address} ${isValidField(address.number) ? address.number : ''}`}
        </span>
      )}
      {isValidField(address.zip) && isValidField(address.city) && (
        <span className="my-settings__text basic basic-16 city">{`${address.zip} ${address.city}`}</span>
      )}
      {isValidField(address.countryIso) && (
        <span className="my-settings__text basic basic-16 country">{renderCountryFieldByIso(address.countryIso)}</span>
      )}
      {isValidField(address.companyName) && (
        <span className="my-settings__text basic basic-16 company-name">{address.companyName}</span>
      )}
      {isValidField(address.companyId) && (
        <span className="my-settings__text basic basic-16 company-id">{address.companyId}</span>
      )}
      {isValidField(address.taxId) && <span className="my-settings__text basic basic-16 tax">{address.taxId}</span>}
    </div>
  );
};

export default AddressCard;
